import { render, staticRenderFns } from "./ExitAuthorization.vue?vue&type=template&id=34e0791e&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ExitAuthorization.vue?vue&type=style&index=0&id=34e0791e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e0791e",
  null
  
)

export default component.exports